/* istanbul ignore file */
/* eslint-disable import/prefer-default-export */
export const MESSAGE_TOPICS = {
  REFRESH: 'move-auth-refresh',
  EXCHANGE: 'move-auth-exchange',
  AUTO_LOGIN: 'move-auth-auto-login',
};
